import { DELETE, execute, FilterConditions, INSERT, SELECT, UPDATE } from "@/utils/database_module";
import { logDebug } from "@/utils/helpers";
import { Category, Devis, Product, SubCategory, SuperCategory, User, UserSession } from "@/utils/types";
import moment from "moment";

const products = {

    getAll : async (filter : {selectedSuperCategoriesIds? : number[], selectedCategoriesIds? : number[], selectedSubCategoriesIds? : number[], selectedOrderColumn? : string, limit? : number, currentPage? : number, searchQuery? : string, is_admin? : boolean, color? : string, startDate? : string, endDate? : string}) => {
        let { selectedSuperCategoriesIds, selectedCategoriesIds, selectedSubCategoriesIds, selectedOrderColumn, limit, currentPage, searchQuery, is_admin, color, startDate , endDate}  = filter 
        const table =  `products p  LEFT JOIN super_categories sc ON p.super_category_id = sc.id LEFT JOIN categories c ON p.category_id = c.id  LEFT JOIN sub_categories subc ON p.sub_category_id = subc.id`
    
        //* Filters
        if (!limit) limit = 100000
        if (!currentPage) currentPage = 1

        const superCategoriesStr =selectedSuperCategoriesIds ? `(${selectedSuperCategoriesIds?.map(superCategoryId => `p.super_category_id = ${superCategoryId}`).join(' OR ')})` : "";
        const categoriesStr = selectedCategoriesIds ? `(${selectedCategoriesIds?.map(categoryId => `p.category_id = ${categoryId}`).join(' OR ')})` : "";
        const subCategoriesStr = selectedSubCategoriesIds ? `(${selectedSubCategoriesIds?.map(subCategoryId => `p.sub_category_id = ${subCategoryId}`).join(' OR ')})` : "";
       
        const colorStr = color ? `p.color =  ${color}` : "";
        const isPublicStr = is_admin ? "" : "p.is_public = 1";
        const searchQueryStr = searchQuery ? `LOWER(p.name) LIKE '%${searchQuery.toLowerCase()}%'` : "";

        const productsstartDateStr = startDate ? `  DATE(p.date) >= '${moment(startDate).format("YYYY-MM-DD")}' ` : "";
        const productsendDateStr = endDate? `  DATE(p.date) <= '${moment(endDate).format("YYYY-MM-DD")}' `: "";
      
        const allFilters = ["p.super_category_id IS NOT NULL", "p.is_deleted = 0", "p.is_primary = 1",superCategoriesStr, categoriesStr, subCategoriesStr, searchQueryStr, colorStr, isPublicStr , productsstartDateStr ,productsendDateStr ];
        const  nonEmptyFilters = allFilters.filter(filter => filter !== "" && filter != "()");
    
        const  orderStr = selectedOrderColumn  && !selectedOrderColumn.includes("name") ? `ORDER BY ${selectedOrderColumn}` : "ORDER BY date DESC";
        const limitStr = !isNaN(parseInt(`${limit * currentPage}`)) ? parseInt(`${limit * currentPage}`) : limit;
        const  columns ="p.*,  sc.name as super_category_name , c.name as category_name, subc.name as sub_category_name";


        const products = await execute(`SELECT ${columns} from ${table} WHERE  ${nonEmptyFilters.join(" AND ")} ${orderStr}  LIMIT ${limitStr}  `) as Product[];

        // console.log("products", products);
        for (const product of products) {
            product.images = product.images ? JSON.parse(`${product.images}`) : [];
            product.sizes =product.sizes ? JSON.parse(`${product.sizes}`) : []
            product.shipping_delay =  JSON.parse(`${product.shipping_delay}`)
            
        } 

        // const devis = (await SELECT("devis", {
        //     conditions: [{ column: "is_deleted", operator: "=", value: 0 }],
        //     order: "min_quantity ASC"
        //   })) as Devis[]
          
        //   const zeroMinQuantityProducts = products.filter(product => product.min_quantity == 0)
          
        //   for (const product of zeroMinQuantityProducts) {
        //     const productDevis = devis.filter(d => d.product_ref == product.reference)
          
        //     product.devis = productDevis
          
        //     if (productDevis.length > 0) {
        //       product.min_quantity = productDevis[0].min_quantity
        //     }
        //     await UPDATE("products", { min_quantity: product.min_quantity }, [{ column: "id", operator: "=", value: product.id }])
        //   }
          
        
        const allProducts = await execute(`SELECT * from products p WHERE ${nonEmptyFilters.join(" AND ")}  `) as Product[];
        return {
            products: products,
            total: allProducts.length,
        }
    },



        getOne : async (id : number , session : UserSession , isProductPage : boolean) => {
        const table =  `products p  LEFT JOIN super_categories sc ON p.super_category_id = sc.id LEFT JOIN categories c ON p.category_id = c.id LEFT JOIN sub_categories subc ON p.sub_category_id = subc.id `
        const [product] = await SELECT( table ,{
                conditions: [{ column: "p.id", operator: "=", value: id }, { column: "p.is_deleted", operator: "=", value: 0 }],
                columns: ["p.*", "sc.name as super_category_name", "c.name as category_name", "subc.name as sub_category_name"]}) as Product[];
       
        if (!product) throw new Error("Product not found");
        
        product.images = product.images ? JSON.parse(`${product.images}`) : [];
        product.sizes =product.sizes ? JSON.parse(`${product.sizes}`) : []
        product.shipping_delay =  JSON.parse(`${product.shipping_delay}`)
        product.sizes =typeof product.sizes == 'string' ? JSON.parse(`${product.sizes}`): product.sizes;
        
        const devis = (await SELECT("devis", {conditions: [{ column: "product_ref",  operator: "=",  value:product.reference ?? "",  },{ column: "is_deleted", operator: "=", value: 0 },],order : "min_quantity ASC"})) as Devis[]
        product.devis = devis;

        const variants = (await SELECT(`products`, { columns:["id", "reference", "images","color", "name"], conditions: [ { column: "reference", operator: "=", value: product.reference!} ,{ column: "id", operator: "<>", value: product.id!}, { column: "is_deleted", operator: "=", value: 0 }, ], })) as Product[];
        for (const variant of variants) {
            variant.images = JSON.parse(`${ variant.images}`);
            // * If we are in the product page, add the variant images to the product images array
            if(isProductPage && variant.id != product.id) {
                for (const image of variant.images) {
                    product.images.push(image)
                }
            }
        }

        if(session?.role=="admin" || session?.role=="super-admin"){
            const [user] = (await SELECT("users", {  conditions: [ {column: "id",operator: "=",value: parseInt(`${product.user_id}`),},]})) as User[];
            user.phone_numbers = JSON.parse(`${user?.phone_numbers}`);
            product.user = user;
        }
        
        product.colors = [...variants , product];
        product.variants = variants;
        // logDebug
        return product
    },



    insert : async (product : SharedFields & SpecificFields) => {
        if (!product.reference) 
            product.reference = generateRandomProductReference();
        const addedProduct = (await INSERT("products", product)) as Product;
        return addedProduct
    },



    update : async (id : number, product :ProductToUpdate) => {
        const variantsSharedFileds = product.sharedFields
        await UPDATE("products", variantsSharedFileds, [{ column: "reference", operator: "=", value: product.actualReference }]);
        
        const productSpecificFileds = product.specificFields
        if (productSpecificFileds) await UPDATE("products", productSpecificFileds, [{ column: "id", operator: "=", value: id }]);

        if (variantsSharedFileds.purchase_price && product.oldPurchasePrice != variantsSharedFileds.purchase_price   ) {
            const details = {
                product_id : id,
                details: {
                    title: "Changement dans le prix d'achat",
                    oldValue: product.oldPurchasePrice,
                    newValue: variantsSharedFileds.purchase_price,
                    user: product.user,
                },
            };
            await INSERT("product_history", details);
        }

        if (variantsSharedFileds.shipping_cost && product.oldShippingCost != variantsSharedFileds.shipping_cost) {
            const details = {
                product_id : id,
                details: {
                    title: "Changement dans le prix de transport",
                    oldValue: product.oldShippingCost,
                    newValue: variantsSharedFileds.shipping_cost,
                    user: product.user,
                },
            };
            await INSERT("product_history", details);
        }

        if(product?.actualReference && variantsSharedFileds.reference &&    product?.actualReference != variantsSharedFileds.reference){
            await UPDATE("devis" , {product_ref  :  variantsSharedFileds.reference }, [{ column: "product_ref" , operator: "=" , value : product?.actualReference }])
        }
        return true

    },

    delete : async (id : number) => {
        await UPDATE("products", { is_deleted: 1 }, [ { column: "id", operator: "=", value: id, }, ]);
        await DELETE("favorites", [{ column: "product_id", operator: '=', value: id }])
        await UPDATE("banners", { is_active: 0 }, [ { column: "product_id", operator: '=', value: id }])

    },

    getHistory : async (id : number) => {
        const history = await SELECT("product_history", { conditions: [{ column: "product_id", operator: "=", value: id, }, ], order : " date DESC",}) as any[];
        return history
    },

    recommend : async (id : number) => {    
        const [product] = await SELECT("products", { conditions: [{ column: "id", operator: "=", value: id, }, ], }) as Product[];    
        const similarProducts = await execute( `SELECT products.* FROM products WHERE (sub_category_id = ${product?.sub_category_id}  OR category_id = ${product?.category_id} OR  super_category_id = ${product?.super_category_id}) AND  products.id <> ${id}   AND products.is_deleted =0 LIMIT 10`) as Product[];
        
        for (const product of similarProducts) {
            if (product.images) product.images = JSON.parse(`${product.images}`);
        }
        return similarProducts
    },

    getSpecialProducts : async (filter : {searchQuery? : string, user_id : number}) => {
        const { searchQuery, user_id } = filter

        const conditions = [{ column: "is_deleted", operator: "=", value: "0" },
            { column: "added_by", operator: "=", value: "user" },
            { column: "is_public", operator: "=", value: "0" },
            { column: "name", operator: "like", value: `%${searchQuery}%` },
        ] as FilterConditions

        if (user_id) conditions!.push({ column: "user_id", operator: "=", value: `${user_id}` }, )
        const specialOrders = await SELECT('products', { conditions: conditions , order : 'date DESC' }) as Product[]
        
        for (const product of specialOrders) {
            product.images = typeof product.images == 'string' ? JSON.parse(`${product.images}`) : product.images
            product.name = typeof product.name == 'string' ? JSON.parse(`${product.name}`) : product.name
        }
        return specialOrders

    }
}

export default products;

type ProductToUpdate = {
    sharedFields : SharedFields,
    specificFields? : SpecificFields ,
    actualReference : string ,
    oldShippingCost? : number ,
    oldPurchasePrice? : number ,
    user? : UserSession ,
  }

type  SharedFields = {
    super_category_id? : number |null,
    sub_category_id? : number |null,
    category_id? : number |null,
    currency? : string ,
    description? :  { en?: string ; fr?: string  , ar?: string }  ,
    name? : { en?: string ; fr?: string  , ar?: string } ,
    reference? : string ,
    tag? : string ,
    views? : number , 
    sizes? : string[] ,
    is_public? : 0 | 1 ,
    added_by? : "admin" | "user"  | "super-admin" ,
    user_id? : number ,
    min_quantity? : number ,
    shipping_delay? : { from?: number ; to?: number } ,
    shipping_cost? : number ,
    purchase_price? : number ,
    price ? : number ,
    total_purchase_price? : number ,
  }

  type SpecificFields = {
    color? : string ,
    rating? : number ,
    images : string ,
    weight? : number ,
    package_info? : {
        width?: number;
        height?: number;
        length?: number;
        quantity?: number;
    } ,
    is_primary? : 0 | 1 ,
    is_deleted? : 0 | 1 ,
  }

function generateRandomProductReference(length = 5) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let reference = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      reference += characters[randomIndex];
    }
    return reference;
  }

  